import {mainRoutes} from './main-routes';

export const schoolAdminRoutes = {
	...mainRoutes,
} as const;
